import { IProductAvailabilityNotification } from '@/types';
import { HttpClient } from './http-client';
import { API_ENDPOINTS } from './api-endpoints';

export const productAvailabilityNotificationsClient = {
  get: (email?: string) =>
    HttpClient.get<IProductAvailabilityNotification[]>(
      `${API_ENDPOINTS.PRODUCT_AVAILABILITY_NOTIFICATIONS}${
        email ? `?search=email:${email}` : ''
      }`,
    ),
  post: (input: IProductAvailabilityNotification) =>
    HttpClient.post<IProductAvailabilityNotification>(
      API_ENDPOINTS.PRODUCT_AVAILABILITY_NOTIFICATIONS,
      input,
    ),
  update: (input: IProductAvailabilityNotification) =>
    HttpClient.put<IProductAvailabilityNotification>(
      `${API_ENDPOINTS.PRODUCT_AVAILABILITY_NOTIFICATIONS}/${input.id}`,
      input,
    ),
  delete: (id: string) =>
    HttpClient.delete<IProductAvailabilityNotification>(
      `${API_ENDPOINTS.PRODUCT_AVAILABILITY_NOTIFICATIONS}/${id}`,
    ),
};
